import { getUtilitiesTemplate } from "@/api/template";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import FileUploader from "@/components/FileUploader/FileUploader";
import Message from "@/components/Message/Message";
import { DownloadOutlined, ThunderboltOutlined } from "@ant-design/icons";

export default function UploadFacilitiesButton({ year }: { year?: number }) {
  return (
    <FileUploader
      uploadType={"utilities"}
      buttonText={"Upload"}
      templateUrlFn={getUtilitiesTemplate}
      note={
        <>
          <Message type="warning">
            <b>Important notes before uploading utility data:</b>
            <ul>
              <li>
                Data must be uploaded per year. Make sure your file contains data that overlaps with
                the selected year ({year}).
              </li>
              <li>
                All existing utility contracts (electricity, heat, water, cooling) for the
                facilities included in your upload that overlap with {year} will be deleted and
                replaced with the new data.
              </li>
              <li>
                Facilities are matched by name. The facility name in your upload must exactly match
                the name in the system.
              </li>
              <li>
                Facilities must have a validated address before you can upload contracts. Without
                this, the system cannot link them to the correct utility datasets.
              </li>
              <li>
                Download the{" "}
                <FileDownloader
                  tooltipText="Download template"
                  fileOutputName={`template-utilities.xlsx`}
                  fileUrlFn={getUtilitiesTemplate}
                  buttonText={"template"}
                  icon={<DownloadOutlined />}
                  type="link"
                />{" "}
                to get started. The template shows the upload format and includes all available
                electricity, water, heat, and cooling datasets.
              </li>
            </ul>
          </Message>
        </>
      }
      uploadParameters={{
        year: year,
      }}
      uploadDataTableProps={{
        rowKey: "key",
        columns: [
          {
            label: "Facility name",
            key: "facility_name",
          },
          {
            label: "Start date",
            key: "start_date",
          },
          {
            label: "End date",
            key: "end_date",
          },
          {
            label: "Dataset",
            key: "dataset",
          },
          {
            label: "Capital owned",
            key: "capital_owned",
          },
          {
            label: "Data input",
            key: "data_input",
          },
          {
            label: "Quantity",
            key: "quantity",
          },
          {
            label: "Percentage",
            key: "percentage",
          },
          {
            label: "Unit",
            key: "unit",
          },
        ],
      }}
      customRender={(props) => (
        <ActionsPopOverItem
          icon={<ThunderboltOutlined />}
          black
          {...props}
        >
          Utilities
        </ActionsPopOverItem>
      )}
    />
  );
}
